import appConstants from '../../../../../../appConstants';
import { mergeUserConfig } from '@dataGrid/gridUtilities';
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';

class GridConfig {
  constructor(configuration) {
    this.config = GridConfig.getConfiguration(configuration);
  }

  static getConfiguration({ userConfig }) {
    const defaultConfig = GridConfig.getDefaultConfiguration();
    return mergeUserConfig({
      defaultConfig,
      userConfig
    });
  }

  static formatCountAndPercentage(params) {
    const field = params.colDef.field;
    const data = params.data[field];
    return `${data.percentage}% | ${data.count}`;
  }

  static tooltipValueGetter(params) {
    return params.value;
  }

  static getDefaultConfiguration() {
    return {
      title: 'Usage Summary',
      enableFilters: false,
      rowSelection: {
        mode: 'singleRow',
        checkboxes: false,
        enableClickSelection: true,
        enableSelectionWithoutKeys: true
      },
      columns: [
        {
          headerName: 'Division',
          field: 'division',
          headerTooltip: 'Division',
          minWidth: appConstants.columnWidth.W_120,
          tooltipValueGetter: GridConfig.tooltipValueGetter,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Region',
          field: 'region',
          headerTooltip: 'Region',
          minWidth: appConstants.columnWidth.W_120,
          tooltipValueGetter: GridConfig.tooltipValueGetter,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Terminal',
          field: 'terminal',
          headerTooltip: 'Terminal',
          minWidth: appConstants.columnWidth.W_120,
          tooltipValueGetter: GridConfig.tooltipValueGetter,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Total Routes',
          field: 'totalRoutes',
          headerTooltip: 'Total Routes',
          minWidth: appConstants.columnWidth.W_120,
          filter: MultiSelectFilter
        },
        {
          headerName: 'City Routes',
          field: 'cityRoutes',
          headerTooltip: 'City Routes',
          minWidth: appConstants.columnWidth.W_120,
          valueGetter: (params) => params.data.cityRoutes.count,
          valueFormatter: GridConfig.formatCountAndPercentage,
          tooltipValueGetter: GridConfig.formatCountAndPercentage,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Trap Routes',
          field: 'trapRoutes',
          headerTooltip: 'Trap Routes',
          minWidth: appConstants.columnWidth.W_120,
          valueGetter: (params) => params.data.trapRoutes.count,
          valueFormatter: GridConfig.formatCountAndPercentage,
          tooltipValueGetter: GridConfig.formatCountAndPercentage,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Manually Created Routes',
          field: 'manuallyCreatedRoutes',
          headerTooltip: 'Manually Created Routes',
          minWidth: appConstants.columnWidth.W_200,
          valueGetter: (params) => params.data.manuallyCreatedRoutes.count,
          valueFormatter: GridConfig.formatCountAndPercentage,
          tooltipValueGetter: GridConfig.formatCountAndPercentage,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Manually Adjusted Routes',
          field: 'manuallyAdjustedRoutes',
          headerTooltip: 'Manually Adjusted Routes',
          minWidth: appConstants.columnWidth.W_200,
          valueGetter: (params) => params.data.manuallyAdjustedRoutes.count,
          valueFormatter: GridConfig.formatCountAndPercentage,
          tooltipValueGetter: GridConfig.formatCountAndPercentage,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Optimization Created Routes',
          field: 'optimizationCreatedRoutes',
          headerTooltip: 'Optimization Created Routes',
          minWidth: appConstants.columnWidth.W_200,
          valueGetter: (params) => params.data.optimizationCreatedRoutes.count,
          valueFormatter: GridConfig.formatCountAndPercentage,
          tooltipValueGetter: GridConfig.formatCountAndPercentage,
          filter: MultiSelectFilter
        },
        {
          headerName: 'System Created Routes',
          field: 'systemCreatedRoutes',
          headerTooltip: 'System Created Routes',
          minWidth: appConstants.columnWidth.W_200,
          valueGetter: (params) => params.data.systemCreatedRoutes.count,
          valueFormatter: GridConfig.formatCountAndPercentage,
          tooltipValueGetter: GridConfig.formatCountAndPercentage,
          filter: MultiSelectFilter
        }
      ]
    };
  }
}

export default GridConfig;
